/**
 * 功能域页 → 相关文章（页面底部「延伸阅读」内链）。
 *
 * 与 posts.js 的 relatedSolutions 正好相反：那边是「文章 → 功能域页」，
 * 这边是「功能域页 → 文章」，合起来构成 文章 ⇄ 功能域 的双向通道。
 *
 * why 要有这个方向：看功能域页的人是「已在评估具体能力」的读者，
 * 他们最需要的是「这件事到底怎么做、坑在哪」的深度文章；
 * 只靠页脚和文章之间的互链，这批人是走不到文章里去的。
 *
 * 维护约定：
 *  - key 必须是 solutions.js 里存在的 slug，value 必须是 posts.js 里存在的 slug；
 *    写错会在页面上渲染成死链，且构建不会报错 —— 所以 Solution.vue 侧对取不到的
 *    slug 一律过滤（与 Post.vue 的 relatedSolutions 同一套防御）。
 *  - 一页配 1～2 篇即可，配多了会抢走「相关能力」区块的注意力。
 *  - 首页只展示 3 篇（按业务线轮流取），所以不必刻意追求每篇文章的入链完全均等。
 */
export const POSTS_FOR_SOLUTION = {
  /* ---- 农业：接入与管控 ---- */
  'device-access': ['smart-agriculture-platform-guide'],
  'device-control': ['smart-agriculture-platform-guide'],

  /* ---- 农业：环境与水肥 ---- */
  'environment-monitoring': ['greenhouse-monitoring-water-fertilizer'],
  'water-fertilizer': ['greenhouse-monitoring-water-fertilizer'],
  'pest-ai': ['greenhouse-monitoring-water-fertilizer', 'smart-agriculture-platform-guide'],

  /* ---- 农业：溯源与多业态 ---- */
  'traceability': ['multi-site-agriculture-digitalization'],
  'four-business-types': ['multi-site-agriculture-digitalization', 'smart-agriculture-platform-guide'],

  /* ---- MES ---- */
  'mes-work-order': ['discrete-manufacturing-mes-guide', 'mes-selection-and-timeline'],
  'mes-quality-trace': ['discrete-manufacturing-mes-guide', 'what-is-mes-vs-erp'],

  /* ---- 工业物联网（暂无工业专题文章，统一指向 MES 实施指南中最贴合现场的部分） ---- */
  'iot-protocol-access': ['discrete-manufacturing-mes-guide'],
  'iot-line-monitoring': ['discrete-manufacturing-mes-guide'],
  'iot-maintenance': ['discrete-manufacturing-mes-guide'],

  /* ---- 农业运营与合规 ---- */
  'farm-weather': ['greenhouse-monitoring-water-fertilizer'],
  'farm-video-security': ['multi-site-agriculture-digitalization'],
  'farm-machine-asset': ['multi-site-agriculture-digitalization'],
  'farm-inventory': ['multi-site-agriculture-digitalization'],
  'farm-finance': ['multi-site-agriculture-digitalization'],
  'farm-compliance': ['smart-agriculture-platform-guide'],
}
